import { render, staticRenderFns } from "./DataTableForManualGrading.vue?vue&type=template&id=466d4377"
import script from "./DataTableForManualGrading.vue?vue&type=script&lang=js"
export * from "./DataTableForManualGrading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports